var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-authorization-file',{ref:"uploadFile",staticStyle:{"width":"700px"},attrs:{"preview-api":_vm.previewApi,"download-api":_vm.downloadApi,"translate-data":{
    downloadTranslate: 'fileUrl'
  },"props-data":{
    disabled: _vm.readOnly,
    bizType: 'inquiry_order',
    attachmentType: 'inquiry_attachment'
  },"request-params":{
    fileGroupId: _vm.fileGroupIdCopy,
    orderId: _vm.orderId,
    tradeId: _vm.tradeId,
    isRelease: _vm.isRelease,
    fileType: 1
  }},model:{value:(_vm.fileGroupIdCopy),callback:function ($$v) {_vm.fileGroupIdCopy=$$v},expression:"fileGroupIdCopy"}})}
var staticRenderFns = []

export { render, staticRenderFns }